import type { JsonDataItem, TypeOrArray } from '../../../types';
import { forceAssert, isArrayDropDownResult } from '../../../utils';
import type { VisibilityCondition } from '../../visibility-condition.interfaces';
import type {
  ITargetValueConverter,
  ValueConverterReturnType,
} from './i-target-value-converter';

export class EntityIdTargetValueConverter implements ITargetValueConverter {
  public convert(
    condition: VisibilityCondition,
    data: JsonDataItem,
  ): TypeOrArray<ValueConverterReturnType> {
    if (condition.sourceFieldId && data?.[condition.sourceFieldId]) {
      const dataItem = data[condition.sourceFieldId];
      const negation = condition.negation || false;
      const filterOperator = condition.filterOperator || 'EQUALS';

      if (Array.isArray(dataItem)) {
        const resolvedData = isArrayDropDownResult(dataItem)
          ? dataItem.map((item) => Number(item.value))
          : dataItem;
        const resolvedTarget = Array.isArray(condition.targetValueId)
          ? condition.targetValueId
          : Number(condition.targetValueId);

        return [resolvedData, resolvedTarget, negation, filterOperator];
      }

      return [
        Number(forceAssert<Record<string, unknown>>(dataItem)?.['value']),
        Number(condition.targetValueId),
        negation,
        filterOperator,
      ];
    }

    // if there is no data then we still need to send back the other pieces so the condition evaluates successfully
    return [
      undefined,
      condition.targetValueId,
      condition.negation || false,
      condition.filterOperator || 'EQUALS',
    ];
  }
}
